export default "__VITE_ASSET__DjM7UJOF__"